export const types ={
    LOGIN: 'AUTH_LOGIN',
    LOGOUT: 'AUTH_LOGOUT'
}